import { createRouter, createWebHistory } from 'vue-router'
import { useAuth } from '@/services/auth'
import LoginView from '../views/LoginView.vue'
import PainelView from '../views/painel/PainelView.vue'
import ProductsView from '@/views/painel/ProductsView.vue'
import CostumersView from '@/views/painel/CostumersView.vue'
import SupplierView from '@/views/painel/SupplierView.vue'
import SalesView from '@/views/painel/SalesView.vue'
import SaleDetailView from '@/views/painel/SaleDetailView.vue'
import OperatorsView from '@/views/painel/OperatorsView.vue'
import StoresView from '@/views/painel/StoresView.vue'
import MovementView from '@/views/painel/MovementView.vue'
import MovementDetailView from '@/views/painel/MovementDetailView.vue'
import CashiersView from '@/views/painel/CashiersView.vue'
import CashierDetailView from '@/views/painel/CashierDetailView.vue'
import PaymentMethodsView from '@/views/painel/PaymentMethodsView.vue'
import SettingsView from '@/views/painel/SettingsView.vue'
import ServicesView from '@/views/painel/ServicesView.vue'
import BudgetsView from '@/views/painel/BudgetsView.vue'
import AgendaView from '@/views/painel/AgendaView.vue'
import ReportsView from '@/views/painel/ReportsView.vue'

const routes = [
  { path: '/login', name: 'login', component: LoginView,
    meta: { title: 'Login' }},
  { path: '/', name: 'painel', component: PainelView,
    meta: { title: 'Painel', auth: true, op: 'usuario' }},
  { path: '/products', name: 'produtos', component: ProductsView,
    meta: { title: 'Produtos', auth: true, op: 'usuario' }},
  { path: '/suppliers', name: 'fornecedores', component: SupplierView,
    meta: { title: 'Fornecedores', auth: true, op: 'usuario' }},
  { path: '/costumers', name: 'clientes', component: CostumersView,
    meta: { title: 'Clientes', auth: true, op: 'usuario' }},
  { path: '/sales', name: 'sales', component: SalesView,
    meta: { title: 'Vendas', auth: true, op: 'usuario' }},
  { path: '/sales/:id', name: 'sale-detail', component: SaleDetailView,
    meta: { title: 'Detalhes da Venda', auth: true, op: 'usuario' }},
  { path: '/movements', name: 'movement', component: MovementView,
  meta: { title: 'Movimentações', auth: true, op: 'usuario' }},
  { path: '/movements/:id', name: 'movement-detail', component: MovementDetailView,
    meta: { title: 'Detalhes da Movimentação', auth: true, op: 'usuario' }},
  { path: '/operators', name: 'operators', component: OperatorsView,
    meta: { title: 'Operadores', auth: true, op: 'usuario' }},
  { path: '/stores', name: 'stores', component: StoresView,
    meta: { title: 'Lojas', auth: true, op: 'usuario' }},
  { path: '/cashiers', name: 'cashiers', component: CashiersView,
    meta: { title: 'Caixas', auth: true, op: 'usuario' }},
  { path: '/cashiers/:id', name: 'cashier-detail', component: CashierDetailView,
    meta: { title: 'Resumo do Caixa', auth: true, op: 'usuario' }},
  { path: '/payment-methods', name: 'payment-methods', component: PaymentMethodsView,
    meta: { title: 'Formas de Pagamento', auth: true, op: 'usuario' }},
  { path: '/settings', name: 'settings', component: SettingsView,
    meta: { title: 'Configurações', auth: true, op: 'usuario' }},
  { path: '/services', name: 'services', component: ServicesView,
    meta: { title: 'Serviços', auth: true, op: 'usuario' }},
  { path: '/budgets', name: 'budgets', component: BudgetsView,
    meta: { title: 'Orçamentos', auth: true, op: 'usuario' }},
  { path: '/agenda', name: 'agenda', component: AgendaView,
    meta: { title: 'Agenda', auth: true, op: 'usuario' }},
  { path: '/reports', name: 'reports', component: ReportsView,
    meta: { title: 'Relatórios', auth: true, op: 'usuario' }},
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to, from, next) => {
  if (to.meta?.auth) {
    const oplevel = to.meta?.op;
    const auth = useAuth();
    if (auth.token && auth.token) {
      const isAuthenticated = await auth.checkAuth(oplevel);
      console.log(isAuthenticated);
      if (isAuthenticated) {
        next();
      } else {
        next({name: 'login'});
      }
    } else {
      next({name:'login'});
    }
  } else {
    next()
  }
  document.title = to.meta.title + ' - LC3 Market' || 'LC3 Market';
  next();
});

export default router
